import { render } from "./PurchaseHistory.vue?vue&type=template&id=1f306400&scoped=true"
import script from "./PurchaseHistory.vue?vue&type=script&lang=js"
export * from "./PurchaseHistory.vue?vue&type=script&lang=js"

import "./PurchaseHistory.vue?vue&type=style&index=0&id=1f306400&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f306400"]])

export default __exports__